import React, { useState, useEffect, useCallback } from 'react';
import { format, startOfMonth, endOfMonth, eachDayOfInterval } from 'date-fns';
import { hu } from 'date-fns/locale';
import AddIcon from '@material-ui/icons/Add';

import { Button, IconButton, Tooltip } from '@material-ui/core';
import NewCarDay from './NewCarDay';
import { NewObjectButton } from '../../../common/table/NewObjectButton';
import ActionMenu from '../../../common/action/ActionMenu';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import { CarDaySetting } from './CarDaySetting';
import WorkIcon from '@material-ui/icons/Work';
import WorkOffIcon from '@material-ui/icons/WorkOff';
import { CookieSetter } from '../../../common/table/CookieSetter';
import RemoveIcon from '@material-ui/icons/Remove';
import { IconWithTooltip } from '../../../common/icons/IconWithTooltip';
import axios from 'axios';

const getCarKey = (car) => {
    return `CarIdAndLicenseNumber(carId=${car.carId}, licenseNumber=${car.licenseNumber})`;
};

function CarDayTable(props) {
    const { data, daysInMonth, refresh } = props;

    useEffect(function () {
        // console.log(data);
    }, [data]);

    return (
        <div className='carday-table-container'>
            <table className="carday-table" border="1">
                <thead>
                    <tr>
                        {<th>Nap</th>}
                        {data.carIds?.map((car) => (
                            <th className='car car-border' key={car.licenseNumber}>
                                {car.licenseNumber}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <>
                        <SumRow data={data} refresh={refresh} />
                        {daysInMonth.map((day) => (
                            <tr className={`${day.type} day-row`} key={day.dateString}>
                                <td className='day-cell'>
                                    <span className="day">{format(day.date, 'dd')}</span>
                                    <span className="day-of-week">{format(day.date, 'EEEE', { locale: hu })}</span>
                                </td>
                                {data.carIds?.map((car) => (
                                    <CarDayCell car={car} day={day} carDay={data.carDaysMap[day.dateString]?.cars[getCarKey(car)]} {...props} />
                                ))}
                            </tr>
                        ))}
                    </>
                </tbody>
            </table>
        </div>

    )
};

function CarDayCell(props) {
    const { day, car, carDay, data, refresh } = props;

    useEffect(function () {
        // if (day.dateString === '2024-11-01') {
        //     console.log(carDay);
        // }
    }, []);

    const setInactiveDay = (car, day) => {
        console.log(car);
        console.log(day);
        const path = '/api/carday';
        const requestObject = {
            "carId": car.carId,
            "licenseNumber": car.licenseNumber,
            "date": day.dateString,
            "active": false
        };
        callApi(path, requestObject).then(refresh);
    }

    const callApi = async (path, request) => {
        const response = await axios.post(path, request)
        console.log(response.data);
    };

    return (
        <td key={day.dateString + car.carId} className={` car-border ${carDay && carDay.active === false && 'nothing'}`}>
            <div className='car-day'>
                <div className='add-button'>
                    <NewObjectButton
                        newObjectLabel={`Új ${carDay && carDay.active ? 'helyszín' : 'nap'}`}
                        refreshState={refresh}
                        dialogContent={(refresh, close) => (
                            <NewCarDay
                                refresh={refresh}
                                close={close}
                                car={car}
                                day={day.date}
                                carDay={carDay}
                            />
                        )}
                        icon={<AddIcon color="primary" fontSize="small" />}

                    />
                </div>
                {carDay?.active && <CarDayDetails {...props} />}
                {carDay === undefined &&
                    <div className='nothing-button'>
                        <Button onClick={() => setInactiveDay(car, day)} >
                            <IconWithTooltip title="semmi" >
                                <RemoveIcon />
                            </IconWithTooltip>
                        </Button>
                    </div>
                }
            </div>
        </td >)
}

function CarDayDetails(props) {
    const { day, car, carDay, data, refresh } = props;

    useEffect(function () {
    }, []);
    const sumRefuelData = (refuels) => {
        let totalLiters = null;
        let totalForint = null;

        refuels.forEach(refuel => {
            if (refuel.refuelingAmountLiter !== null) {
                totalLiters = (totalLiters ?? 0) + refuel.refuelingAmountLiter;
            }
            if (refuel.refuelingAmountForint !== null) {
                totalForint = (totalForint ?? 0) + refuel.refuelingAmountForint;
            }
        });

        return {
            refuelingAmountLiter: totalLiters,
            refuelingAmountForint: totalForint
        };
    };
    const refuelAmount = (refuel) => {
        let result = "";
        if (refuel.refuelingAmountLiter) {
            result = `${refuel.refuelingAmountLiter}l`
        }
        return result;
    }
    const getRefuel = useCallback(() => {
        if (carDay) {
            if (carDay?.refuels) {
                const refuel = sumRefuelData(carDay?.refuels);
                const refuelA = refuelAmount(refuel);
                // console.log(refuel);
                return carDay?.refuels && <Tooltip title={`Tankolás ${refuelA}`}><LocalGasStationIcon color='primary' /></Tooltip>;
            }
            return "";
        }
        return "";
    }, [data]);

    return (<>
        <div className='car-details'>
            <div className='car-details-header'>
                <div className='driver-name'>{carDay?.driverName}<div className='refuel-icon'>{getRefuel()}</div></div >
                <div className='right-side'>
                    <div className='km-header'>km</div >
                    <div className='action-menu'><ActionMenu row={carDay} tabletype={'carday'} refresh={refresh} /></div>
                </div>
            </div>
            {carDay?.locations.map((location) => (
                <div className='location-row'>
                    <div className='location-name'>{location.locationName || location.projectLocation}</div>
                    <div className='right-side'>
                        <div className='km-header'>{location.km}</div >
                        <div className='action-menu'><ActionMenu row={location} date={carDay.date} tabletype={'cardaylocation'} refresh={refresh} /></div>
                    </div>
                </div>
            ))}
        </div>

    </>
    )
}

function SumRow(props) {

    const { data } = props;

    return (
        <tr className='sum-row'>
            <td className='sum-amount'>Összesen</td>
            {data.carIds?.map((car) => (
                <td className='sum-amount' key={car.licenseNumber}>
                    <div><Tooltip title="Tankolás"><LocalGasStationIcon color='primary' /></Tooltip>: {car.sumRefuelLiter ? car.sumRefuelLiter : 0} l, {car.sumRefuelForint ? car.sumRefuelForint : 0} Ft</div>
                    <div><Tooltip title="Munka km"><WorkIcon color='primary' /></Tooltip>: {car.sumProjectKm ? car.sumProjectKm : 0} km
                        <Tooltip title="Egyéb km"><WorkOffIcon color='primary' /></Tooltip>: {car.sumOtherKm ? car.sumOtherKm : 0} km</div>
                </td>
            ))}
        </tr>
    )
};
export default CarDayTable;